import React from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CInput3 from "../../../basecomp/components/CInput3";
import ImageUploadVM from "../viewmodel/ImageUploadVM";
import CButton from "../../../basecomp/components/CButton";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteModal from "../../ImageComponent/DeleteModal";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import CBackDrop from "../../../basecomp/components/CBackDrop";

const ImageView = () => {
  const {
    materialReq,
    setMaterialReq,
    handleFileChange,
    handleSubmit,
    inputBoxValueName,
    previewImages,
    loadingData,
    handleConfirmDelete,
    handleCloseModal,
    handleDeleteClick,
    openModal,
    getImageName,
    fileSelected,
    loading
  } = ImageUploadVM();

   // Get permissions from localStorage
   const permissionData = localStorage.getItem("permissionData") || "";
   const permissions = permissionData.split(",");

   // Check specific permissions
   const canDeleteUser = permissions.includes("feature_warehouse_img_delete");

  return (
    <>
      <Grid item xs={10} sm={8} md={10} sx={{ margin: "5em 1em 0.5em 1em" }}>
        <Card sx={{ padding: "2em" }}>
          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            >
            <Grid item xs={12} sm={6} md={3}>
              <CInput3
                id="material_req"
                cHintText={inputBoxValueName}
                cVariant="outlined"
                cValue={materialReq}
                cOnChange={(e) => setMaterialReq(e.target.value)}
                cFullWidth={true}
                cType='material_req'
              />
            </Grid>
          </Grid>
          <CBackDrop cOpen={loading} />
          {previewImages.length === 5 && (
            <p style={{ textAlign: "center" }}>
              Maximum you can upload 5 material images
            </p>
          )}

          {!loadingData && materialReq.length >= 5 && (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}>
              {!loading && (
                <>
                  {previewImages.length === 0 ? (
                    <p style={{ width: "100%", textAlign: "center" }}>
                      Material images are not present
                    </p>
                  ) : (
                    previewImages.map((imageUrl, index) => (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          width: "250px",
                          height: "250px",
                          margin: "10px",
                          overflow: "hidden",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                        }}>
                        {canDeleteUser && (
                          <IconButton
                            aria-label="delete"
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              zIndex: "1",
                              backgroundColor: "white",
                              borderRadius: "50%",
                            }}>
                            <DeleteIcon
                              style={{ color: "green" }}
                              onClick={() => handleDeleteClick(imageUrl)}
                            />
                          </IconButton>
                        )}
                        <DeleteModal
                          open={openModal}
                          onClose={handleCloseModal}
                          onConfirm={handleConfirmDelete}
                          cFileName={getImageName(imageUrl)}
                        />
                        <img
                          src={imageUrl}
                          alt={`${index + 1}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    ))
                  )}

                  {previewImages.length < 5 && (
                    <div
                      style={{
                        width: "250px",
                        height: "250px",
                        margin: "10px",
                        position: "relative",
                      }}>
                      <div
                        style={{
                          width: "100%",
                          height: fileSelected === 0 ? "210px" : "165px",
                          border: "1px dashed #ccc",
                          borderRadius: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}>
                        <IconButton
                          component="span"
                          onClick={() => {
                            const fileInput =
                              document.getElementById("image-id");
                            if (fileInput) {
                              fileInput.click();
                            }
                          }}>
                          <AddAPhotoIcon />
                          <input
                            id="image-id"
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                            multiple
                          />
                        </IconButton>
                      </div>
                      {fileSelected > 0 && (
                        <p style={{ textAlign: "center", marginTop: "10px" }}>
                          {fileSelected} files selected{" "}
                        </p>
                      )}

                      <div style={{ marginTop: "10px", display:"flex", justifyContent:'center',alignItems:'center'}}>
                        <CButton
                          cText="Upload"
                          cTooltipText="Submit the action"
                          cDisabled={false}
                          cOnClick={handleSubmit}
                          CFullWidth={true}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </Card>
      </Grid>
    </>
  );
};

export default ImageView;
